import {EntityState} from '@ngrx/entity';
import {TrackEntity} from './entities/track-entity.model';

export type TrackState = EntityState<TrackEntity>;
